import type { configType } from './types';

const getStylesForShadowDom = () => {
	const styles = document.createElement('style');
	styles.textContent =
		'.overlay { position: fixed; z-index: 1000; width: 100vw; height: 100vh; height: 100dvh; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, 0.5); display: flex; flex-flow: row nowrap; justify-content: center; align-items: center; } .iframe { border: none; user-select: none; visibility: hidden; position: absolute; } .iframe.visible { visibility: visible; } .close-modal { font-family: Manrope, sans-serif; width: 90%; max-width: 620px; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 9999; box-shadow: 0px 54px 200px rgba(36, 37, 57, 0.2); display: flex; flex-flow: column nowrap; justify-content: flex-start; align-items: center; padding: 35px; border-radius: 8px; background: #fff; box-sizing: border-box; } .close-modal * { box-sizing: border-box; } .close-modal__text { margin: 40px auto 30px; font-weight: 600; font-size: 24px; line-height: 36px; text-align: center; color: #242539; text-wrap: pretty; } .close-modal__button-container { width: 318px; display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center; } .close-modal__button { background: #fff; border: 2px solid #edeef3; border-radius: 74px; width: 152px; height: 56px; cursor: pointer; font-weight: 600; font-size: 14px; line-height: 21px; color: #2b2d56; text-transform: uppercase; } .close-modal__button--exit { background: #151515; box-shadow: 0px 8px 34px rgba(156, 163, 175, 0.6); color: #fff; border-color: transparent; }';
	return styles;
};

const prepareOverlayNode = () => {
	const overlay = document.createElement('div');
	overlay.classList.add('overlay');
	const loader = document.createElement('div');
	loader.classList.add('loader-container');
	// tslint:disable:max-line-length
	loader.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" stroke="rgb(255, 255, 255)" width = '100' height = '100' viewBox="0 0 44 44" > <g fill="none" fill-rule="evenodd" stroke-width="1"> <circle cx="22" cy="22" r="1" stroke-width="1"> <animate attributeName="r" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20" /> <animate attributeName="stroke-opacity" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0" /> </circle> <circle cx="22" cy="22" r="1" stroke-width="1"> <animate attributeName="r" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20" /> <animate attributeName="stroke-opacity" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0" /> </circle> </g> </svg>
	`;
	overlay.appendChild(loader);
	return overlay;
};

const prepareIframeNode = (url: string) => {
	const iframe = document.createElement('iframe');
	iframe.setAttribute('src', url);

	iframe.setAttribute('width', '100%');
	iframe.setAttribute('height', '100%');
	iframe.id = 'onRampWidget';

	iframe.setAttribute(
		'allow',
		'microphone; camera; clipboard-read; clipboard-write'
	);
	iframe.classList.add('iframe');

	return iframe;
};

export const importFonts = () => {
	if (document.querySelector('[data-onramp-font]')) {
		return;
	}
	const font = document.createElement('link');
	font.setAttribute(
		'href',
		'https://fonts.googleapis.com/css?family=Manrope:wght@400;600;700;800&display=swap'
	);
	font.setAttribute('rel', 'stylesheet');
	font.setAttribute('data-onramp-font', '');
	document.head.appendChild(font);
};

export const prepareCloseModalNode = () => {
	const container = document.createElement('div');
	container.classList.add('close-modal');
	const textEl = document.createElement('div');
	textEl.classList.add('close-modal__text');
	textEl.textContent = 'Are you sure you want to leave & close this widget ?';
	const buttonContainer = document.createElement('div');
	buttonContainer.classList.add('close-modal__button-container');
	const cancelButton = document.createElement('button');
	cancelButton.setAttribute('type', 'button');
	cancelButton.classList.add('close-modal__button');
	cancelButton.classList.add('close-modal__button--cancel');
	cancelButton.textContent = 'Cancel';
	cancelButton.addEventListener('click', function (event) {
		event.stopPropagation();
		window.postMessage(
			{
				eventData: {
					type: 'ONRAMP_WIDGET_CLOSE_REQUEST_CANCELLED',
					isOnramp: true,
				},
			},
			window.location.origin
		);
	});
	const exitButton = document.createElement('button');
	exitButton.setAttribute('type', 'button');
	exitButton.classList.add('close-modal__button');
	exitButton.classList.add('close-modal__button--exit');
	exitButton.textContent = 'Exit';
	exitButton.addEventListener('click', function (event) {
		event.stopPropagation();
		window.postMessage(
			{
				eventData: {
					type: 'ONRAMP_WIDGET_CLOSE_REQUEST_CONFIRMED',
					isOnramp: true,
				},
			},
			window.location.origin
		);
	});
	buttonContainer.appendChild(cancelButton);
	buttonContainer.appendChild(exitButton);
	container.appendChild(textEl);
	container.appendChild(buttonContainer);
	return container;
};

const hasOwn = (obj: unknown, prop: string) =>
	Object.prototype.hasOwnProperty.call(obj, prop);

export const initDOMNodeWithOverlay = (
	url: string,
	theme?: configType['theme'],
	containerId?: `#${string}`
) => {
	const body = document.querySelector('body');
	const iframe = prepareIframeNode(url);

	// Container mode - render iframe directly in container
	if (containerId) {
		const container = document.querySelector(containerId);
		if (!container) {
			throw new Error(
				`Container with selector '${containerId}' not found`
			);
		}

		// Apply theme attributes
		if (theme) {
			const attrs: { [key: string]: string } = {};
			for (const [mode, values] of Object.entries(theme)) {
				switch (mode) {
					case 'lightMode':
					case 'darkMode':
						for (const [key, value] of Object.entries(
							values || {}
						)) {
							attrs[
								String(
									`theme-${mode === 'lightMode' ? 'light' : 'dark'}-${key}`
								)
							] = value;
						}
						break;
					case 'default':
						attrs['theme-default'] = String(values);
						break;
				}
			}
			iframe.setAttribute('name', JSON.stringify(attrs));
		}

		container.appendChild(iframe);

		return {
			body: body,
			iframe: iframe,
			overlay: null,
			shadow: null,
			shadowHost: null,
			container: container,
		};
	}

	// Shadow DOM mode - render with overlay
	const shadowHost = document.createElement('div');
	shadowHost.id = 'onRampWidgetContainer';
	shadowHost.style.width = '100%';
	shadowHost.style.height = '100%';
	const shadow = shadowHost.attachShadow({ mode: 'open' });
	shadow.appendChild(getStylesForShadowDom());
	const overlay = prepareOverlayNode();

	overlay.appendChild(iframe);
	shadow.appendChild(overlay);

	// Apply theme attributes
	if (theme) {
		const attrs: { [key: string]: string } = {};
		for (const [mode, values] of Object.entries(theme)) {
			switch (mode) {
				case 'lightMode':
				case 'darkMode':
					for (const [key, value] of Object.entries(values || {})) {
						attrs[
							String(
								`theme-${mode === 'lightMode' ? 'light' : 'dark'}-${key}`
							)
						] = value;
					}
					break;
				case 'default':
					attrs['theme-default'] = String(values);
					break;
			}
		}
		iframe.setAttribute('name', JSON.stringify(attrs));
	}

	return {
		body: body,
		iframe: iframe,
		overlay: overlay,
		shadow: shadow,
		shadowHost: shadowHost,
		container: null,
	};
};

const isValidHex = (hex: string) => {
	const hexRegex = /^#([0-9A-F]{3}){1,2}$/i;
	return hexRegex.test(hex);
};

const isValidPhoneNumber = (phoneNumber: string): boolean => {
	const encodedRegex = /^%2[Bb]\d+-\d+$/;
	return encodedRegex.test(phoneNumber);
};

export const sanityCheck = (config: configType) => {
	if (!hasOwn(config, 'appId')) {
		throw new Error('appId missing when initializing constructor');
	}

	if (hasOwn(config, 'phoneNumber')) {
		if (
			typeof config.phoneNumber !== 'string' ||
			!isValidPhoneNumber(config.phoneNumber)
		) {
			throw new Error(
				'Invalid phoneNumber format. Expected URL-encoded "+countryCode-phoneNumber" format; use encodeURIComponent to encode the phone number'
			);
		}
	}

	if (
		hasOwn(config, 'flowType') &&
		[1, 2, 3].includes(Number(config.flowType))
	) {
		if (hasOwn(config, 'network') && typeof config.network !== 'string') {
			throw new Error(
				'network only accepts string values. Check param values at https://docs.onramp.money/onramp/widget-integration/hosted-mode#customisation-onramp'
			);
		}

		if (hasOwn(config, 'coinAmount') && hasOwn(config, 'fiatAmount')) {
			throw new Error('use either coinAmount or fiatAmount');
		}

		if (
			hasOwn(config, 'coinAmount') &&
			typeof config.coinAmount !== 'number'
		) {
			throw new Error('coinAmount only accepts number values');
		}

		if (
			hasOwn(config, 'fiatAmount') &&
			typeof config.fiatAmount !== 'number'
		) {
			throw new Error('fiatAmount only accepts number values');
		}

		if (
			hasOwn(config, 'paymentMethod') &&
			!(config?.paymentMethod === 1 || config?.paymentMethod === 2)
		) {
			throw new Error(
				'paymentMethod only accepts number values as 1 => UPI, 2 => Bank Transfers'
			);
		}
	}

	if (hasOwn(config, 'flowType') && [4].includes(Number(config.flowType))) {
		if (hasOwn(config, 'sellAmount') && hasOwn(config, 'receiveAmount')) {
			throw new Error('use either sellAmount or receiveAmount');
		}
		if (hasOwn(config, 'sellAmount') && hasOwn(config, 'receiveAmount')) {
			throw new Error('use either sellAmount or receiveAmount');
		}
	}

	if (hasOwn(config, 'addressTag') && !hasOwn(config, 'walletAddress')) {
		throw new Error('addressTag can only be used along with walletAddress');
	}

	if (hasOwn(config, 'memo')) {
		throw new Error(
			'The memo parameter has been deprecated! Please use the addressTag parameter.'
		);
	}

	if (hasOwn(config, 'theme')) {
		if (
			!hasOwn(config.theme, 'lightMode') &&
			!hasOwn(config.theme, 'darkMode')
		) {
			throw new Error(
				'Theme object cannot be empty! Please define a theme.'
			);
		}

		//lightMode
		if (hasOwn(config.theme, 'lightMode')) {
			if (hasOwn(config.theme?.lightMode, 'baseColor')) {
				if (!isValidHex(String(config.theme?.lightMode?.baseColor))) {
					throw new Error('Invaid baseColor provided for lightMode!');
				}
			} else {
				throw new Error(
					'baseColor property is mandatory for setting theme.'
				);
			}
		}
		//darkMode
		if (hasOwn(config.theme, 'darkMode')) {
			if (hasOwn(config.theme?.darkMode, 'baseColor')) {
				if (!isValidHex(String(config.theme?.darkMode?.baseColor))) {
					throw new Error('Invaid baseColor provided for darkMode!');
				}
			} else {
				throw new Error(
					'baseColor property is mandatory for setting theme.'
				);
			}
		}
	}

	if (hasOwn(config, 'widgetUrl')) {
		try {
			if (!config.widgetUrl) {
				throw new Error('Empty widget url not allowed');
			}
			const widgetUrl = new URL(config.widgetUrl as string);
			if (
				![
					'test.onramp.money',
					'onramp.money',
					'onramp.trbns.com',
				].includes(widgetUrl.hostname)
			) {
				throw new Error(
					`Invalid widgetUrl origin: ${widgetUrl.hostname}, url must be from an authorized domain`
				);
			}
		} catch (e) {
			throw e;
		}
	}

	if (hasOwn(config, 'containerId')) {
		if (!config.containerId) {
			throw new Error('Empty containerId not allowed');
		} else if (String(config.containerId)[0] !== '#') {
			throw new Error('containerId must start with #');
		}
	}

	return true;
};

// returns time for performance metrics
export const getTime = () => {
	try {
		return performance?.now();
	} catch (e) {
		console.log('getTime failed', e);
		return 0;
	}
};
